<template>
  <div class="home">
    <div class="box" ref="box">
      <div class="smallbox" ref="smallbox" @mouseover="showsmall" @mouseout="dissmall" @mousemove="movesmall">
        <img src="../assets/g.jpg" alt="" width="350" class="smallimg" />
        <div class="mask" ref="mask"></div>
      </div>
      <div class="bigBox" ref="bigbox">
        <img src="../assets/g.jpg" alt="" width="800" class="bigimg" ref="bigimg"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  methods: {
    showsmall(){
      this.$refs.mask.style.display = 'block';
      this.$refs.bigbox.style.display = 'block';
    },
    dissmall(){
       this.$refs.mask.style.display = 'none';
      this.$refs.bigbox.style.display = 'none';
    },
    movesmall(event){
      var spaceX = this.getPage(event).x - this.$refs.box.offsetLeft;
      var spaceY = this.getPage(event).y - this.$refs.box.offsetTop;
      var x = spaceX - this.$refs.mask.offsetWidth/2;
      var y = spaceY - this.$refs.mask.offsetHeight/2;
      if(x<=0){x=0};
      if(y<=0){y=0};

      var maskMaxX = this.$refs.smallbox.offsetWidth - this.$refs.mask.offsetWidth;
      var maskMaxY = this.$refs.smallbox.offsetHeight - this.$refs.mask.offsetHeight;

      if(x>=maskMaxX){x=maskMaxX}
      if(y>=maskMaxY){y=maskMaxY}

      this.$refs.mask.style.left = x+'px';
      this.$refs.mask.style.top = y + 'px';

      console.log(this.$refs.bigimg.offsetWidth,this.$refs.bigbox.offsetWidth)
      var xRate = (this.$refs.bigimg.offsetWidth - this.$refs.bigbox.offsetWidth) / maskMaxX;
      this.$refs.bigimg.style.left = -xRate * x + 'px';
      var yRate = (this.$refs.bigimg.offsetHeight - this.$refs.bigbox.offsetHeight) / maskMaxY;
      this.$refs.bigimg.style.top = -yRate * y +'px'

     
    },
    getPage(e){
      return {
            x: e.pageX || e.clientX + document.documentElement.scrollLeft,
            y: e.pageY || e.clientY + document.documentElement.scrollTop
        }
    }
  },
  mounted() {},
};
</script>
<style lang="less" scope>
  .box{
    width: 350px;
    height: 350px;
    margin: auto;
    border: 1px solid #ccc;
    position: relative;
    .bigBox{
      width: 350px;
      height: 350px;
      position: absolute;
      top: 0px;
      left: 360px;
      border: 1px solid #ccc;
      overflow: hidden;
      display: none;
      img{
        position: absolute;
      }
    }
    .mask{
      width: 175px;
      height: 175px;
      position: absolute;
      top: 1px;
      left: 1px;
      cursor: move;
      opacity: 0.5;
      display: none;
      background-color: rgb(73, 158, 236);
    }
    .smallbox{
      position: relative;
    }
    img{
      vertical-align: top;
    }
  }
</style>
